import { nanoid } from 'nanoid';

// A request id from create(), or true from a link made before requests had ids.
export type ICommentFocusRequest = string | true;

// Requests to open a note with its comment bar focused. Each is acted on once, so coming back to the
// same address (back from the note's editor, Back and Forward) does not focus the bar again, and the
// address never has to be rewritten to forget it.
export class CommentFocusRequests {
    // grows by one id per comment button tap, for the life of the app
    private handled = new Set<string>();

    create = (): string => {
        return nanoid();
    };

    isPending = (request?: ICommentFocusRequest): boolean => {
        if (request === true) {
            return true;
        }
        return request !== undefined && !this.handled.has(request);
    };

    markHandled = (request: ICommentFocusRequest) => {
        // a request without an id cannot be told apart from the next one, so it is never put aside
        if (request !== true) {
            this.handled.add(request);
        }
    };
}
